// src/components/Contact/Contact.jsx
import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Contact.css';

// Firebase Firestore bağlantımız kanka
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

// React Icons kütüphanesinden kurumsal ikonlar
import { FiMapPin, FiPhone, FiMail, FiClock, FiSend, FiCheckCircle } from 'react-icons/fi';

function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Firebase'e 'contacts' koleksiyonu altında mesajı kaydediyoruz kanka
      await addDoc(collection(db, 'contacts'), {
        ...formData,
        date: new Date().toISOString(),
        read: false // Okundu / okunmadı takibi için güzel bir alan
      });

      setSubmitted(true);
    } catch (error) {
      console.error("Mesaj gönderilirken hata oluştu:", error);
      alert("Mesaj gönderilemedi kanka, lütfen daha sonra tekrar dene.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Navbar />

      {/* Üst Başlık (Hero) */}
      <div className="contact-header">
        <div className="contact-header-overlay"></div>
        <div className="container">
          <h1 className="page-title">İletişim</h1>
          <p className="page-subtitle-text">Hukuki danışmanlık ve randevu talepleriniz için bizimle iletişime geçin.</p>
          <p className="page-breadcrumb">Ana Sayfa / İletişim</p>
        </div>
      </div>

      {/* İletişim Ana Bölüm */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            
            {/* Sol Taraf: İletişim Bilgileri */}
            <div className="contact-info-box">
              <h2 className="contact-heading">İletişim <span className="gold-text">Bilgileri</span></h2>
              <div className="title-underline-left"></div>
              <p className="contact-desc">
                Hukuki uyuşmazlıklarınızda hak kayıpları yaşamamak ve profesyonel destek almak için ofisimizle telefon, e-posta veya doğrudan randevu yoluyla irtibat kurabilirsiniz.
              </p>

              <div className="info-items">
                <div className="info-item">
                  <div className="info-icon"><FiMapPin /></div>
                  <div>
                    <h4>Ofis Adresi</h4>
                    <p>Yİhsaniye Mah. 4903 Sk. No:18 Mert Plaza Kat:4 No:15 Akdeniz/Mersin</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon"><FiPhone /></div>
                  <div>
                    <h4>Telefon</h4>
                    <p>+90 551 079 19 59</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon"><FiMail /></div>
                  <div>
                    <h4>E-Posta</h4>
                    <p> avemreuygun@gmail.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon"><FiClock /></div>
                  <div>
                    <h4>Çalışma Saatleri</h4>
                    <p>Pazartesi - Cuma: 09:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Sağ Taraf: Mesaj Gönderme Formu */}
            <div className="contact-form-box">
              <h3 className="form-box-title">Bize <span className="gold-text">Ulaşın</span></h3>
              <p className="form-box-desc">Formu doldurun, en kısa sürede hukuki değerlendirme ile size dönüş yapalım.</p>

              {submitted ? (
                <div className="success-message-box">
                  <FiCheckCircle className="success-icon" />
                  <h4>Mesajınız Alındı!</h4>
                  <p>Talebiniz başarıyla iletildi. En kısa süre içinde sizinle iletişime geçilecektir.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <input 
                      type="text" 
                      name="name" 
                      placeholder="Adınız Soyadınız" 
                      value={formData.name} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>

                  <div className="form-row">
                    <input 
                      type="email" 
                      name="email" 
                      placeholder="E-Posta Adresiniz" 
                      value={formData.email} 
                      onChange={handleChange} 
                      required 
                    />
                    <input 
                      type="tel" 
                      name="phone" 
                      placeholder="Telefon Numaranız" 
                      value={formData.phone} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <input 
                      type="text" 
                      name="subject" 
                      placeholder="Konu (Örn: Boşanma Davası Danışmanlığı)" 
                      value={formData.subject} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <textarea 
                      name="message" 
                      rows="5" 
                      placeholder="Hukuki durumunuzu kısaca özetleyin..." 
                      value={formData.message} 
                      onChange={handleChange} 
                      required 
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-btn" disabled={loading}>
                    <span>{loading ? 'Gönderiliyor...' : 'Mesajı Gönder'}</span> <FiSend />
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;